import { useMeetingStore } from '@/host/stores';
import { EventService } from '../../../host/services/event.service';
import { BaseEventRouter } from '../../../shared/app/BaseEventRouter';

export class BreakoutRoomEventRouter extends BaseEventRouter {
  private readonly boundHandleUserRoomChangeEvent = this.handleUserRoomChangeEvent.bind(this);
  private readonly boundHandleUserRoomEnded = this.handleUserRoomEnded.bind(this);

  registerEventListeners(): void {
    this.eventService.on(
      'vo.meeting.breakout.initiated.topic',
      this.boundHandleUserRoomChangeEvent
    );
    this.eventService.on('vo.meeting.breakout.ended.topic', this.boundHandleUserRoomEnded);
  }
  unregisterEventListeners(): void {
    this.eventService.off(
      'vo.meeting.breakout.initiated.topic',
      this.boundHandleUserRoomChangeEvent
    );
    this.eventService.off('vo.meeting.breakout.ended.topic', this.boundHandleUserRoomEnded);
  }
  constructor(eventService: EventService) {
    super(eventService, 'BreakoutRoomEventRouter');
  }

  async sendBreakoutSessionCreatedEvent(user_pid: string, data: any): Promise<void> {
    const currentRoomPid = useMeetingStore.getState().getCurrentRoomPid();
    const payload = {
      user_pid,
      meeting_pid: currentRoomPid,
      room_pid: currentRoomPid,
      data,
    };
    this.eventService.emit('vo.meeting.breakout.initiated', payload);
  }

  async sendBreakoutSessionEndedEvent(user_pid: string, data: any): Promise<void> {
    const currentRoomPid = useMeetingStore.getState().getCurrentRoomPid();
    const payload = {
      user_pid,
      meeting_pid: currentRoomPid,
      room_pid: currentRoomPid,
      data,
    };
    this.eventService.emit('vo.meeting.breakout.ended', payload);
  }
  async handleUserRoomEnded(event: any): Promise<void> {
    try {
      //useBreakoutRoomStore.getState().loadSessionsFromRoomId(event.room_pid);
      const breakoutEvent = new CustomEvent('breakoutSessionEnded', { detail: event });
      window.dispatchEvent(breakoutEvent);
    } catch (error) {
      console.log('❌ Error handling UserRoomChanged event:', error);
    }
  }
  async handleUserRoomChangeEvent(event: any): Promise<void> {
    try {
      const breakoutEvent = new CustomEvent('breakoutSessionCreated', { detail: event });
      window.dispatchEvent(breakoutEvent);
    } catch (error) {
      console.log('❌ Error handling UserRoomChanged event:', error);
    }
  }
}
